// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  padding-inline: 0;
}

.cursor-no {
  cursor: none;
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-self-exclude/popover-self-exclude.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF","sourcesContent":["ion-title {\r\n  padding-inline: 0;\r\n}\r\n\r\n.cursor-no {\r\n  cursor: none;\r\n  visibility: hidden\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
